import { useEffect, useState } from "react";
import { createDraftScheduler } from "@/lib/prompt-draft-topic";

/** Sends the input bar's draft for the topic check on a typing pause. */
export function usePromptDraft(value: string, enabled: boolean): void {
  const [scheduler] = useState(createDraftScheduler);
  useEffect(() => {
    scheduler.schedule(enabled ? value : "");
  }, [scheduler, value, enabled]);
  useEffect(() => scheduler.cancel, [scheduler]);
}
